module.exports = __webpack_public_path__ + "img/upload-icon-up.c5d3719d.svg";